import script from "./CommuteDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./CommuteDashboard.vue?vue&type=script&setup=true&lang=js"

import "./CommuteDashboard.vue?vue&type=style&index=0&id=1bfb6f9a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bfb6f9a"]])

export default __exports__